import { useDrag } from 'react-dnd';
import style from '../Milestone.module.css';
import clockIcon from 'assets/img/clock.svg';
import messageTextIcon from 'assets/img/message-text-square.svg';
import checkIcon from 'assets/img/check-square.svg';
import Chip from 'shared/UI/Chip';
import moment from 'moment-timezone';
import { copyToClipboard, getPlainText, getPriorityStatus } from 'utils/Helpers';
import ArrowDown from 'assets/img/arrow-down.svg';
import dotsThreeIcon from 'assets/img/DotsThree.svg';
import { Dropdown } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import AvatarGroup from '../../shared/AvatarGroup';
import KebabMenu from '../../shared/KebabMenu';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import namer from 'color-namer';
import ArrowDown1 from 'assets/img/arrow-down.png';
import AddMilestoneCard from '../AddMilestoneCard';
import { useSocket } from '../../context/SocketContext';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    style={{ cursor: 'pointer' }}
    onClick={(e) => {
      e.stopPropagation();
      onClick(e);
    }}>
    {children}
  </div>
));

const DraggableCard = ({
  index,
  handleMilestoneClick,
  milestone,
  viewMode,
  handleDeleteMilestone,
  handleSubtaskClick,
  showSubtasks,
  toggleSubtasks,
  members,
  statusOptions,
  isProjectRelatedBoard,
  handleCloneMilestone,
  handleArchiveMilestone,
  projectBoardId,
  reminderOptions,
  isTemplateActive = false
}) => {
  const socket = useSocket();
  const [{ opacity, className }, dragRef] = useDrag(
    () => ({
      type: 'MILESTONE_CARD',
      item: { _id: milestone?._id },
      collect: (monitor) => ({
        // opacity: monitor.isDragging() ? 0.5 : 1,
        className: monitor.isDragging() ? style.card_wrapper_active : ''
      }),
      canDrag: !viewMode
    }),
    [milestone?._id, viewMode]
  );
  const [showAddSubtask, setShowAddSubtask] = useState(false);

  // const totalNumberOfTasks = milestone?.checklist?.length;
  // const totalNumberOfTasksCompleted = milestone?.checklist.filter((value) => value.isCompleted).length;
  const dueOn = milestone.kbDueDate && moment(milestone.kbDueDate).format('MMM DD');
  const isOverdue = milestone.kbDueDate && moment(milestone.kbDueDate).endOf('day').isBefore(moment());
  const totalNumberOfComments =
    milestone?.activities?.filter((value) => value.activityType === 'milestone_comment')?.length || null;
  const isArchived = milestone.isArchived;

  const handleCompleteSubtask = (milesoneId, subtaskId, value = false) => {
    // let masterSocket = socket;
    let status;
    let selectedBoardId = projectBoardId;
    if (value) {
      status = statusOptions.find((x) => x.value === '687940ccdd4622df947a0325').value;
    }else{
      status = statusOptions.find((x) => x.value === '687940ccdd4622df947a032b').value;
    }
    console.log({ id: subtaskId, milestoneId: milesoneId, payload: { status: status } });
    socket?.emit('update-subtask', {
      id: subtaskId,
      milestoneId: milesoneId,
      payload: { status: status },
      projectBoardId: selectedBoardId
    });
  };

  const handleCompletetask = (milesoneId, value = false) => {
    // let masterSocket = socket;
    let selectedBoardId = projectBoardId;
    let completeStatus = statusOptions.find((x) => x.label === 'Complete').value;
    console.log({ milestoneId: milesoneId, payload: { status: completeStatus } });
    socket?.emit('update-milestone', {
      id: milesoneId,
      payload: { isCompleted: !value },
      projectBoardId: selectedBoardId
    });
  };

  return (
    <>
      <div
      ref={dragRef}
        className={`${style.card_wrapper} ${milestone.isCompleted ? style.card_wrapper_greenbodr : ''}  ${className} ${index === 0 ? 'mt-0' : ''}`}
        onClick={handleMilestoneClick}
        // style={{ opacity }}
        >
        {milestone?.labelIds && milestone?.labelIds?.length > 0 && !isTemplateActive &&(
          <div className={style.milestone_color_box_cover}>
            {milestone?.labelIds?.map((x, i) => (
              <div key={i} className={style.tooltipWrapper}>
                <Tippy
                  // content={`Color: ${namer(x.color).ntc[0].name}, title: ${x?.name}`}
                  content={x?.name}
                  placement="top"
                  arrow={true}>
                  <div className={style.milestone_box_color} style={{ backgroundColor: x.color }}>
                    &nbsp;
                  </div>
                </Tippy>
                {/* <span className={style.tooltipText}>{x?.name}</span> */}
              </div>
            ))}
          </div>
        )}
        <div className={`${style.title_wrapper}`}>
          <div className={style.title}>{milestone?.name}</div>

          {!viewMode && (
            <div>
              <KebabMenu
                showAddSubtask={() => setShowAddSubtask(true)}
                onClone={() => handleCloneMilestone(milestone._id)}
                onDelete={() => handleDeleteMilestone(milestone._id)}
                onArchieve={() => {
                  handleArchiveMilestone(milestone._id, !isArchived);
                }}
                isArchived={isArchived}
                onCopy={() => {
                  const link = `/project-board/${isProjectRelatedBoard ? 'project' : 'board'}/${
                    milestone?.projectId?._id || milestone?.projectBoardId
                  }/${milestone?._id}`;
                  copyToClipboard(link, isProjectRelatedBoard);
                }}
                handleCompletetask={() => handleCompletetask(milestone?._id, milestone?.isCompleted)}
                isCompletedtask={milestone?.isCompleted}
              />
            </div>
          )}
        </div>
        {(dueOn || milestone?.totalChecklist > 0 > 0 || totalNumberOfComments || milestone?.priority?.name) && (
          <div className={`d-flex justify-content-between align-items-center ${style.milestoneProperties_div}`}>
            <div className="d-flex" style={{ gap: '10px' }}>
              {dueOn && (
                <div className={`${style.task} ${isOverdue && !milestone.isCompleted ? 'overdue-color' : milestone.isCompleted ? "completed-color" : ''}`}>
                  <img src={clockIcon} alt="clock-icon" />
                  {dueOn}
                </div>
              )}
              {milestone?.totalChecklist > 0 && (
                <div className={style.task}>
                  <img src={checkIcon} alt="clock-icon" /> {milestone?.completedChecklist}/{milestone?.totalChecklist}
                </div>
               )}

              {totalNumberOfComments && (
                <div className={style.task}>
                  <img src={messageTextIcon} alt="clock-icon" /> {totalNumberOfComments}
                </div>
              )}
            </div>
            {milestone?.priority?.name && (
              <Chip label={milestone?.priority?.name} variant={getPriorityStatus(milestone?.priority?.name)} />
            )}
          </div>
        )}
        
        {milestone.assigneeIds.length > 0 && !isTemplateActive && (
          <div className={style.milestonecard_avatar}>
            <AvatarGroup
              size={25}
              members={members}
              membersList={milestone.assigneeIds}
              isCalender={true}
              // showAddIcon={showAddIcon}
            />
          </div>
        )}
        {/* {console.log(milestone)} */}

        {milestone.subtask.length > 0 && (
          <div
            className="saubTask"
            onClick={(e) => {
              e.stopPropagation();
              toggleSubtasks();
            }}>
            <img
              src={ArrowDown1}
              alt="ArrowDown-icon"
              className={`${style.ArrowDown} ${showSubtasks ? style.rotated : ''}`}
            />
            <p>{milestone.subtask.length} Subtasks</p>
          </div>
        )}
      </div>
      {showSubtasks &&
        milestone.subtask?.length > 0 &&
        milestone?.subtask?.map((subtask, key) => {
          const totalNumberOfTasks = subtask?.checklist?.length;
          const totalNumberOfTasksCompleted = subtask?.checklist?.filter((value) => value.isCompleted)?.length;
          const dueOn = subtask.dueDate && moment(subtask.dueDate).format('MMM DD');
          const isOverdue = subtask.dueDate && moment(subtask.dueDate).endOf('day').isBefore(moment());
          const totalNumberOfComments =
            subtask?.activities?.filter((value) => value.activityType === 'subtask_comment')?.length || null;

          return (
            <>
              <div
                key={subtask._id}
                className={`${style.card_wrapper} ${style.subtask_card_wrapper}`}
                onClick={() => handleSubtaskClick(subtask)}
                // ref={dragRef}
                style={{ opacity }}>
                <div className={style.title_wrapper}>
                  <div className={style.title}>{getPlainText(subtask?.name)}</div>

                  {!viewMode && (
                    <KebabMenu
                      hideClone={true}
                      onDelete={() => handleDeleteMilestone(subtask._id, subtask?.milestoneId, true)}
                      onCopy={() => {
                        const link = `/project-board/${isProjectRelatedBoard ? `project` : `board`}/${
                          milestone?.projectId?._id || milestone?.projectBoardId
                        }/${subtask?.milestoneId}/${subtask?._id}`;
                        copyToClipboard(link);
                      }}
                      isSubtask={true}
                      handleCompleteSubtask={() =>
                        handleCompleteSubtask(
                          subtask?.milestoneId,
                          subtask?._id,
                          subtask?.status?._id === '687940ccdd4622df947a032b' || false
                        )
                      }
                      isCompletedtask={subtask?.status?._id === '687940ccdd4622df947a032b'}
                    />
                  )}
                </div>
                <div
                  className={`d-flex justify-content-between align-items-center 2  ${style.milestoneProperties_div}`}>
                  <div className="d-flex" style={{ gap: '10px' }}>
                    {dueOn && (
                      <div className={`${style.task} ${isOverdue ? 'overdue-color' : ''}`}>
                        <img src={clockIcon} alt="clock-icon" />
                        {dueOn}
                      </div>
                    )}
                    {subtask?.totalChecklist > 0 && (
                      <div className={style.task}>
                        <img src={checkIcon} alt="clock-icon" /> {subtask?.completedChecklist}/{subtask?.totalChecklist}
                      </div>
                    )}

                    {totalNumberOfComments && (
                      <div className={style.task}>
                        <img src={messageTextIcon} alt="clock-icon" /> {totalNumberOfComments}
                      </div>
                    )}
                  </div>
                  <Chip
                    label={statusOptions?.find((x) => x.value === subtask?.status?._id)?.label}
                    variant={getPriorityStatus(statusOptions?.find((x) => x.value === subtask?.status?._id)?.label)}
                  />
                </div>
                <div className={style.milestonecard_avatar}>
                  {subtask.assignees.length > 0 && !isTemplateActive &&(
                    <AvatarGroup
                      size={25}
                      members={members}
                      membersList={subtask.assignees}
                      isCalender={true}
                      // showAddIcon={showAddIcon}
                    />
                  )}
                </div>
                {/* {console.log(milestone)} */}
              </div>
            </>
          );
        })}
      {showAddSubtask && (
        <AddMilestoneCard
          projectBoardId={milestone.projectBoardId}
          statusId={''}
          statusName={''}
          isProjectRelatedBoard={isProjectRelatedBoard}
          members={members}
          priorityOptions={statusOptions}
          reminderOptions={reminderOptions}
          isSubtask={true}
          milestoneId={milestone._id}
          setShowAddSubtask={setShowAddSubtask}
        />
      )}
    </>
  );
};

export default DraggableCard;
